// extracted by mini-css-extract-plugin
export var section = "styles-module--section--Cv3gS";
export var container = "styles-module--container--zFJmO";